
function arcgisSearchExtensionParams(searchTerm,doSearch,useInfer){
  doSearch = doSearch || true;
  useInfer = useInfer || true;
  stem(searchTerm,doSearch);
  return searchItems(useInfer);
}

// from main.js
function searchItems(useInfer) {

    var query_to_display = "",
      query = "";

    if (useInfer) {


      if (intent_user) {
        query += " owner:" + intent_user;
      }

      if (cleaned_results && cleaned_results.length > 0) {
        query += " " + cleaned_results.join(" ");
      }

      if (intent_type) {
        if (query.length > 0) {
          //query += " AND ";
        }
        var types = intent_type.split(',');
        query += " (";
        //for (i in types) {
        for (var i=0 ; i<types.length ; i++) {
          var type = types[i];
          query += "type:\"" + type + "\"";
          if (i < types.length - 1) {
            query += " OR ";
          }
        }
        query += ")";
      }

      if (intent_timerange) {
        query += " uploaded:" + intent_timerange;
      }

      if (negative_intent_keywords) {
        var neg_keywords = negative_intent_keywords.split(",");
        //for (i in neg_keywords) {
        for (var i=0 ; i<neg_keywords.length ; i++) {
          query += " -type:\"" + neg_keywords[i] + "\"";
        }

      }

      if (!intent_user && negative_tags) {
        var neg_tags = negative_tags.split(",");
        //for (i in neg_tags) {
        for (var i=0 ; i<neg_tags.length ; i++) {
          query += " -tags:\"" + neg_tags[i] + "\"";
        }

      }

      if (intent_keywords) {
        var temp_keywords_arr = intent_keywords.split(",");
        //for (i in temp_keywords_arr) {
        for (var i=0 ; i<temp_keywords_arr.length ; i++) {
          query += " typekeywords:\"" + temp_keywords_arr[i] + "\"";
          if (i < temp_keywords_arr.length - 1) {
            query += " OR ";
          }
        }
      }

      if (intent_tags) {
        query += " tags:" + intent_tags;
      }

      if (intent_extent) {
        //add bbox
        query += "&bbox=" + intent_extent;
      }

      if (intent_sort && intent_sortField) {
        //query += "&sortOrder:" + intent_sort + "&sortField:" + intent_sortField;
      }
      query = query.trim();

    } else {
      query = original_query.trim();
      query += ' -type:"Code Attachment" -type:"Featured Items" -type:"Symbol Set" -type:"Color Set" -type:"Windows Viewer Add In" -type:"Windows Viewer Configuration"  -type:"Code Attachment" -type:"Featured Items" -type:"Symbol Set" -type:"Color Set" -type:"Windows Viewer Add In" -type:"Windows Viewer Configuration"';
    }
    var sortField = ["modified","title"].indexOf(intent_sortField) > -1 ? intent_sortField : "";

  return({query:query,sortOrder:intent_sort,sortField:sortField})
  //return query;
  }
